import React from 'react';
import { Card } from 'antd';

const ComparisonMetricCard = ({ 
    title, 
    fbaValue, 
    fbmValue, 
    suffix = '', 
    icon: IconComponent,
    description,
    precision = 0
}) => {
    // Format values based on precision
    const formatValue = (value) => {
        if (precision > 0) {
            return parseFloat(value || 0).toFixed(precision);
        }
        return (value || 0).toString();
    };

    const formattedFbaValue = formatValue(fbaValue);
    const formattedFbmValue = formatValue(fbmValue);

    return (
        <Card
            size="small"
            style={{
                background: '#fff',
                borderRadius: '12px',
                boxShadow: '2px 4px 9px -5px rgba(0,0,0,0.08)',
                border: '1px solid #f5f5f5',
                height: '72px',
            }}
            styles={{
                body: {
                    padding: '5px 14px',
                    height: '100%'
                }
            }}
        >
            {/* Header with title and icon */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '2px'
            }}>
                <span style={{
                    color: '#8c8c8c',
                    fontSize: '11px',
                    fontWeight: '500'
                }}>
                    {title}
                </span>
                <IconComponent style={{
                    fontSize: '12px',
                    color: '#8c8c8c'
                }} />
            </div>

            {/* Values comparison */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '2px'
            }}>
                {/* FBA Value */}
                <div style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '2px'
                }}>
                    <span style={{
                        color: '#FF9900',
                        fontSize: '17px',
                        fontWeight: 'bold',
                        lineHeight: '1.2'
                    }}>
                        {parseFloat(formattedFbaValue).toLocaleString()}
                    </span>
                    {suffix && (
                        <span style={{
                            color: '#FF9900',
                            fontSize: '9px',
                            fontWeight: '400'
                        }}>
                            {suffix}
                        </span>
                    )}
                </div>

                {/* VS separator */}
                <span style={{
                    color: '#d9d9d9',
                    fontSize: '10px',
                    fontWeight: '500',
                    margin: '0 4px'
                }}>
                    vs
                </span>

                {/* FBM Value */}
                <div style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '2px'
                }}>
                    <span style={{
                        color: '#1890ff',
                        fontSize: '17px',
                        fontWeight: 'bold',
                        lineHeight: '1.2'
                    }}>
                        {parseFloat(formattedFbmValue).toLocaleString()}
                    </span>
                    {suffix && (
                        <span style={{
                            color: '#1890ff',
                            fontSize: '9px',
                            fontWeight: '400'
                        }}>
                            {suffix}
                        </span>
                    )}
                </div>
            </div>

            {/* Description with FBA/FBM labels */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                fontSize: '9px',
                color: '#8c8c8c'
            }}>
                <span style={{ color: '#FF9900', fontWeight: '500' }}>FBA</span>
                <span style={{ fontSize: '8px' }}>{description}</span>
                <span style={{ color: '#1890ff', fontWeight: '500' }}>FBM</span>
            </div>
        </Card>
    );
};

export default ComparisonMetricCard;
